<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-17 16:09:13
--> 
<template>
  <mrc_ess_skeleton_loader :loading='$store.state.uuid ? skeletonloading : false'>
    <v-card>
      <v-card-text>
        <mrc_ess_switch v-if="$store.state.uuid"
                        :true-value="'1'"
                        :false-value="'0'"
                        :readonly="disabled"
                        v-model="list.is_used"></mrc_ess_switch>
        <!--版本管理-->
        <v-row>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_multiText :label="$t('label_system_version_name')+'*'"
                               :error-messages="$errors('list', 'version_name', requiredRule.concat(nocharacter))"
                               :isNational="judegNational('version_name')"
                               v-model="list.version_name"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_multiText :label="$t('label_system_version_code')+'*'"
                               :error-messages="$errors('list', 'version_code', requiredRule)"
                               :isNational="judegNational('version_code')"
                               v-model="list.version_code"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_prompt :label="this.$t('label_The_product_name')+'*'"
                            :rules='false'
                            :disabled='disabled'
                            :errMsg="$errors('list','system_platform',requiredRule)"
                            v-model="list.system_platform"
                            obj="product">
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_dictName v-model="list.version_type"
                              :disabled="disabled"
                              :label="$t('label_Client_type') + '*'"
                              multiple
                              :errMsg="$errors('list', 'version_type', requiredRule)"
                              dict_name="client_type">
            </mrc_ess_dictName>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_note')"
                               noRequired
                               :error-messages="$errors('list', 'remark', nocharacter)"
                               :isNational="judegNational('remark')"
                               v-model="list.remark"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success='success'
                         @cancel='cancel'
                         :loading='btnIsLoading'
                         v-if='!disabled'></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script> 
import {
  getVersionList
  , addVersion
  , updateVersion
  , deleteVersion
  , detailVersion
} from '@/service/api/version.js'
import { required, maxLength, between, email, url } from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      skeletonloading: true,
      list: {},
      btnIsLoading: false,
      viewList: {},
    };
  },
  computed: {
  },
  created () { },
  watch: {},
  async mounted () {
    this.national('mrbase_sys_version')
    if (this.$store.state.uuid) {
      this.getDetail()
    }
    else {

    }
  },

  methods: {
    paramsChange () { },
    async getDetail () {
      this.skeletonloading = true
      const res = await detailVersion({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.list = res.data
        this.list.version_type = this.list.version_type.indexOf(',') != -1 ? this.list.version_type.split(',') : (this.list.version_type ? [this.list.version_type] : [])
      }
      else {
      }
      this.skeletonloading = false
    },
    async success () {
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      let list = this.$clone(this.list)
      Array.isArray(list.version_type) && list.version_type.length > 0 ? list.version_type = list.version_type.join() : ''
      // this.list.version_type = this.list.version_type.join()
      if (this.$store.state.uuid) {
        updateVersion(this.$deletefield(null, list)).then(async res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_operation_was_successful') })
            await this.getDetail()
            this.$emit('changeReadonly')
          }
        })
      }
      else {
        // this.$router.push({ name: 'version' })
        addVersion({ ...list, is_used: '1' }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_added_successfully') })
            if (this.$route.params.type == 'internation') {
              this.$router.push({ name: 'internationIndex' })
            }
            else {
              this.$router.push({ name: 'version' })
            }
          }
          else {
            // this.list.version_type = this.list.version_type.split()
          }
        })
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getDetail()
        this.$emit('changeReadonly')
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit')
        }).then(res => {
          if (this.$route.params.type == 'internation') {
            this.$router.push({ name: 'internationIndex' })
          }
          else {
            this.$router.push({ name: 'version' })
          }
        }).catch(err => { })
      }

    },
  },
  validations: {
    list: {
      system_platform: {
        required
      },
      version_name: {
        required, nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      version_code: {
        required,
        // nocharacter (value) {
        //   return this.$myVerify.nocharacter(this.INT(value))
        // },
      },
      version_type: {
        required
      },
      remark: {
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      }
    }
  },
};
</script>

<style scoped>
</style>

